<template>
    <div class="performancemanagement">
        <div class="header">
            <el-row>
                <el-col :span="6">
                    <label class="headerlabel">用户信息</label>
                    <el-input v-model="param.UserInfo" placeholder="请输入用户编号" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">评分</label>
                    <el-select v-model="param.Score" placeholder="请选择" class="autowidth" clearable >
                        <el-option v-for="item in Scorelist" :label="item" :value="item"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">月份</label>
                    <el-date-picker
                    v-model="param.StatisticalDate"
                    type="month"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    placeholder="选择月">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" style="margin-left: 24px;" @click="init">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <el-table
            :data="ConsultantScoreList"
            style="width: 100%">
                <el-table-column prop="UserID" label="用户ID"></el-table-column>
                <el-table-column label="头像">
                    <template slot-scope="scope">
                        <el-avatar :size="48" :src="scope.row.ZHeadPhotoURL"></el-avatar>
                    </template>
                </el-table-column>
                <el-table-column prop="RealName" label="姓名"></el-table-column>
                <el-table-column prop="ConsultNum" label="咨询个数"></el-table-column>
                <el-table-column prop="Score" label="管理员评分"></el-table-column>
                <el-table-column prop="GoodRatio" label="好评率"></el-table-column>
                <el-table-column prop="gBadRatio" label="差评率"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <div v-if="!scope.row.ScoreKey">
                            <el-popover placement="bottom" title="评分" width="200">
                                <el-rate v-model="scope.row.Score" :colors="colors" @change="changescore(scope.row)"></el-rate>
                                <el-button type="text" slot="reference">评分</el-button>
                            </el-popover>
                        </div>
                        <div v-else>
                            --
                        </div>
                        
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageIndex"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

    </div>
</template>
<script>
export default{
    data() {
        return {
            param:{
                pageIndex:1,
                pageSize:10,
                PageTotal:0,
                UserInfo:'',
                Score:'',
                StatisticalDate:new Date().getFullYear()+'-'+(new Date().getMonth()<9?'0':'')+(new Date().getMonth()+1),
                ExportFlag:'',//1-导出 0-不导出
            },
            Scorelist:[1,2,3,4,5],
            ConsultantScoreList: [],
            colors: ['#99A9BF', '#F7BA2A', '#FF9900']
        }
    },
    watch:{
        'param.StatisticalDate'(newval,oldval){
            if(newval==''){
                this.param.StatisticalDate=new Date().getFullYear()+'-'+(new Date().getMonth()<9?'0':'')+(new Date().getMonth()+1);
            }
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init(){
            this.$Http_Post('/statistics/getConsultantScoreList',this.param).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.ConsultantScoreList=res.Data;
                    this.param.PageTotal=res.Counts;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        handleinitialization(val){
            this.param.pageIndex=val;
            this.init();
        },
        // 评分改变时触发
        changescore(val){
            this.$Http_Post('/statistics/sumbitConsultantScore',{UserID:val.UserID,Score:val.Score,StatisticalDate:val.StatisticalDate}).then(res=>{
                if(res.Code==0 || res.Code==200){
                    this.$message.success(res.Message);
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        // 重置
        reset(){
            this.param=this.$options.data().param;
            this.init();
        }
    },
}
</script>
<style>
.performancemanagement .header{background: #fff;padding: 36px;}
.performancemanagement .header .headerlabel{width:90px;display: inline-block;}
.performancemanagement .header .autowidth{width: 240px;}
.performancemanagement .MainContent{background: #fff;padding:48px 16px;margin:16px 0;}
</style>